// @flow

import * as React from 'react';
import { GoogleApiWrapper, Map } from 'google-maps-react';

type Props = {
  google: any,
  latitude: number,
  longitude: number,
  zoom: number,
  children: React.Node,
  updateLocation?: Function,
  onClick: Function,
  googleIsReady: Function,
  apiKey: string,
}

class GoogleMap extends React.PureComponent<Props> {
  componentDidMount() {
    this.props.googleIsReady(true);
  }

  render() {
    return (
      <Map
        mapTypeControl={false}
        streetViewControl={false}
        google={this.props.google}
        zoom={this.props.zoom}
        initialCenter={{
          lat: this.props.latitude,
          lng: this.props.longitude,
        }}
        style={{ width: '100%', height: '100%' }}
        onDragend={(mapProps, map) => {
          if (this.props.updateLocation) {
            const geocoder = new this.props.google.maps.Geocoder;
            const location = { lat: map.center.lat(), lng: map.center.lng() };
            geocoder.geocode({ location }, (results) => {
              if (results && results.length > 0 && results[results.length - 1].address_components
                && results[results.length - 1].address_components.length > 0) {
                const countryCode = results[results.length - 1].address_components[0].short_name;
                this.props.updateLocation(countryCode);
              }
            });
          }
        }}
        onClick={this.props.onClick}
        onDragstart={this.props.onClick}
      >
        {
          this.props.children
        }
      </Map>
    );
  }
}

export default GoogleApiWrapper(props => ({
  apiKey: props.apiKey,
}))(GoogleMap);
